import { Pipe, PipeTransform } from '@angular/core';
import {environment} from "../../environments/environment";

@Pipe({
  name: 'companyImage',
  standalone: true
})
export class CompanyImagePipe implements PipeTransform {

  transform(filename: string): string {
    return `${environment.api.endpoint}assets/img/uploads/${filename}`;
  }

}
